export default __webpack_public_path__ + "static/media/KIA.84dd9146.jpg";